var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('markdown-viewer',{model:{value:(_vm.markdown),callback:function ($$v) {_vm.markdown=$$v},expression:"markdown"}})}
var staticRenderFns = []

export { render, staticRenderFns }